import HeaderSection from "./sections/headerSection";
import BannerSection from "./sections/bannerSection";
import StartSliderSection from "./sections/startSliderSection";
import AboutSection from "./sections/aboutSection";
import ServicesSection from "./sections/servicesSection";
import TreatmentSection from "./sections/treatmentSection";
import TeamSection from "./sections/teamSection";
import ChooseSection from "./sections/chooseSection";
import TeamSectionTwo from "./sections/teamSectionTwo";
import TestimonialsSection from "./sections/testimonialsSection";
import FaqSection from "./sections/faqSection";
import BlogsSection from "./sections/blogsSection";
import FooterSection from "./sections/footerSection";

const HomeFourteen = () => {
  return (
    <>
      <HeaderSection />
      <BannerSection />
      <StartSliderSection />
      <AboutSection />
      <ServicesSection />
      <TreatmentSection />
      <TeamSection />
      <ChooseSection />
      <TeamSectionTwo />
      <TestimonialsSection />
      <FaqSection />
      <BlogsSection />
      <FooterSection />
    </>
  );
};

export default HomeFourteen;
